import { render, staticRenderFns } from "./FullTokenDialog.vue?vue&type=template&id=6f0a35b2&scoped=true&"
import script from "./FullTokenDialog.vue?vue&type=script&lang=js&"
export * from "./FullTokenDialog.vue?vue&type=script&lang=js&"
import style0 from "./FullTokenDialog.vue?vue&type=style&index=0&id=6f0a35b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a35b2",
  null
  
)

export default component.exports